<template>
    <section class="container" v-if="Loaded">
        <section class="panel center-block">
            <div class="container-fluid">
                <!-- CACHER SI PAS TESTEUR-->
                <div class="mb-4" v-show="$parent.IsTesteur()">
                    <router-link class="btn btn-warning" to="/ListeQuestions">&lsaquo;&lsaquo; Retour</router-link>
                </div>
                <!-- FIN CACHER SI PAS TESTEUR-->
                <div class="card bg-primary" v-show="Reponse.ReponseCorrecte===true">
                    <!-- BG PRIMARY POUR SUCCESS -->
                    <div class="text-center">
                        <i class="icon smiley-happy"></i>
                        <h1 class="text-white">Bien joué, vous avez trouvé la bonne réponse !</h1>
                    </div>
                    <ul v-for="answer in Reponse.Reponses" :key="answer">
                        <li>{{answer}}</li>
                    </ul>
                    <p class="text-center">Cette réponse vous a rapporté <span class="text-warning">{{Reponse.NombrePoints}} point(s)</span>.</p>
                </div><!-- CARD-->
                <div class="card bg-warning" v-show="Reponse.ReponseCorrecte===false">
                    <!-- BG DARK POUR ERREUR -->
                    <div class="text-center">
                        <i class="icon smiley-unhappy"></i>
                        <h1 class="text-white">Oups...vous n’avez pas donné la bonne réponse !</h1>
                        <p>Les bonnes réponses étaient:</p>
                    </div>
                    <ul v-for="answer in Reponse.Reponses" :key="answer">
                        <li>{{answer}}</li>
                    </ul>
                    <p class="text-center">Vous n’avez pas tout perdu, votre participation vous rapporte <span class="text-primary">{{Reponse.NombrePoints}}  point(s)</span>.</p>
                </div><!-- CARD-->
                <div class="editor mt-5" v-html="Reponse.ComplementReponse">
                    <!-- ISSUS DE L'EDITEUR EN BO-->




                </div><!-- EDITOR-->


                <div class="video__player mt-4" v-if="Reponse.LienVideo!==null && Reponse.LienVideo!==''">
                    <div>
                        <iframe width="560" height="315" :src="Reponse.LienVideo" frameborder="0" allowfullscreen></iframe>
                    </div>
                </div>
                <div class="mt-4" v-if="Reponse.Image!==null">
                    <img :src="$parent.GetPathFileId(Reponse.Image)" style="max-width:100%;" />
                </div>
                <a download class="btn btn-download btn-light btn-download mt-4" v-if="Reponse.Document!=null" :href="$parent.GetPathDocId(Reponse.Document)">
                    <i class="icon icon-doc"></i> {{Reponse.TitreDocument}}
                </a>
                <a v-if="Reponse.TitreLien!==null" :href="Reponse.Lien" class="btn btn-download btn-light btn-download mt-4" target="_blank">
                    <i class="icon icon-link"></i> {{Reponse.TitreLien}}
                </a>

                <h2 style="display:none" class="hauracherell text-center text-primary mt-5" v-if="$parent.IsParticipant()===true">
                    Vous êtes <span class="text-warning">
                        {{Reponse.Stats.Ordre}}
                    </span> de notre classement avec <span class="text-warning">{{Reponse.Stats.NombrePoints}} point(s).<br /></span>
                    Rendez-vous demain pour la question suivante.
                </h2>
                <h3 class="hauracherell">Voici les statistiques du challenge en cours</h3>
                <div class="group__circle">
                    <div class="circle bg-primary">
                        <p>{{Reponse.Stats.TauxParticipation}} %</p>
                        <p>de<br>participation</p>
                    </div>
                    <div class="circle bg-warning">
                        <p>{{Reponse.Stats.TauxBonnesReponses}} %</p>
                        <p>de bonnes<br>réponses</p>
                    </div>
                    <div class="circle bg-warning">
                        <p>{{Reponse.Stats.MoyenTempReponse}} s</p>
                        <p>de temps<br>de réponse</p>
                    </div>
                </div><!-- D FLEX-->
                <div class="ranking ranking--primary" v-show="StatsLoaded">
                    <ul>
                        <li class="second"><span>2</span><strong v-html="GetParticipantOrder(2)"></strong></li>
                        <li class="first"><span>1</span><strong v-html="GetParticipantOrder(1)"></strong></li>
                        <li class="tertiary"><span>3</span><strong v-html="GetParticipantOrder(3)"></strong></li>
                    </ul>
                    <h3 class="hauracherell">Classement des collaborateurs</h3>
                    <!-- <div class="panel-bottom"></div> -->
                </div><!--RANKING-->
                <div class="ranking ranking--warning" v-show="StatsLoaded">
                    <ul>
                        <li class="second"><span>2</span><strong v-html="GetGroupeOrder(2)"></strong></li>
                        <li class="first"><span>1</span><strong v-html="GetGroupeOrder(1)"></strong></li>
                        <li class="tertiary"><span>3</span><strong v-html="GetGroupeOrder(3)"></strong></li>
                    </ul>
                    <h3 class="hauracherell">Classement des {{Reponse.IntituleGroupe}}</h3>
                    <!-- <div class="panel-bottom"></div> -->
                </div><!--RANKING-->
            </div>
        </section><!-- PANEL -->
        <span class="panel-bottom"></span>
        <section class="modal" v-bind:class="{ modalopen: modalOpen_required }" key="modal">
            <div class="modal-content bg-danger">
                <p class="text-center">
                    <i class="icon smiley-tongue"></i>
                </p>
                <p>Attention, pour relever le défi de la question du jour, vous devez quand même y répondre!</p>
                <button class="btn btn-border-white d-inline-block" v-on:click="modalOpen_required = ! modalOpen_required">Fermer la fenêtre</button>
            </div>
        </section><!-- MODAL-->
    </section><!-- CONTAINER FLUID-->
</template>

<script>
    import $ from 'jquery';
    import { Utility } from '../configs/configpaths';
    export default {
        data: function () {

            return {

                modalOpen_required: false,
                Reponse: {
                    ReponseCorrecte: false, Reponses: [], Stats: {}
                },
                STATS: null,
                StatsLoaded: false,
                Loaded: false
            };
        },


        mounted: function () {

            var _self = this;
            _self.$parent.GloablEvents();
            document.getElementById('app').scrollIntoView();
            var CURRENT_USER = Utility.GetCurrent();

            var TOKEN = Utility.GetToken();
            if (!CURRENT_USER) {
                _self.$router.push('/');
            }

            var settings = {
                "crossDomain": true,
                "url": _self.BASE_URL + "api/question/Result",
                "data": {
                    "questionId": parseInt(_self.$route.params.id),
                    "participant": parseInt(CURRENT_USER.Id),
                    "challenge": parseInt(CURRENT_USER.Challenge),
                    "isTesteur": CURRENT_USER.Role === "TESTEUR"
                },
                "method": "GET",
                "headers": {
                    'Authorization': 'Bearer ' + TOKEN
                }
            };

            $.ajax(settings).done(function (response) {
                _self.Reponse = response;
                if (_self.Reponse.LienVideo) {
                    _self.Reponse.LienVideo = _self.Reponse.LienVideo.replace("watch?v=", "embed/");
                    _self.Reponse.LienVideo = _self.Reponse.LienVideo.replace("feature=youtu.be", "");
                }

                _self.Loaded = true;
                _self.GetStats();
            });
        },
        methods: {

            GetStats: function () {
                var _self = this;

                var CURRENT_USER = Utility.GetCurrent();
                var TOKEN = Utility.GetToken();
                if (!CURRENT_USER) {

                    _self.$router.push('/');
                }
                var settings = {
                    "async": false,
                    "crossDomain": true,
                    "url": _self.BASE_URL + "api/Question/Stats",
                    "data": {
                        "id": CURRENT_USER.Id,
                    },
                    "method": "GET",
                    "headers": {
                        'Authorization': 'Bearer ' + TOKEN
                    }
                };

                $.ajax(settings).done(function (response) {


                    _self.STATS = response;
                    _self.StatsLoaded = true;
                }).fail(function () {


                });
            },
            GetParticipantOrder: function (index) {
                var CURRENT_USER = Utility.GetCurrent();
                if (CURRENT_USER.Role === "TESTEUR")
                    return "";
                if (this.STATS != null) {

                    try {
                        return this.STATS.ClassementParicipants[index - 1].Nom + "<br/>" + this.STATS.ClassementParicipants[index - 1].NombrePoints + " points";
                    } catch (e) {
                        return "";
                    }
                }

            },
            GetGroupeOrder: function (index) {
                var CURRENT_USER = Utility.GetCurrent();
                if (CURRENT_USER.Role === "TESTEUR")
                    return "";

                if (this.STATS != null) {

                    try {
                        return this.STATS.ClassementMagasins[index - 1].Magasin + "<br/>" + this.STATS.ClassementMagasins[index - 1].NombrePoints + " points";
                    } catch (e) {
                        return "";
                    }
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
